"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductPageImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing ProductPage operations. */
var ProductPageImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class ProductPage class.
   * @param client Reference to the service client
   */
  function ProductPageImpl(client) {
    (0, _classCallCheck2["default"])(this, ProductPageImpl);
    this.client = client;
  }
  /**
   *  (Auth: RhinestoneAuthorize[productCode, portalId])
   * @param portalId (Access Controlled)
   * @param productCode (Access Controlled)
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(ProductPageImpl, [{
    key: "getProductPageConfiguration",
    value: function getProductPageConfiguration(portalId, productCode, options) {
      var operationArguments = {
        portalId: portalId,
        productCode: productCode,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getProductPageConfigurationOperationSpec);
    }
  }]);
  return ProductPageImpl;
}(); // Operation Specifications


exports.ProductPageImpl = ProductPageImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getProductPageConfigurationOperationSpec = {
  path: "/api/Portals({portalId})/ProductPages/{productCode}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.ProductPageDto
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.productCode],
  headerParameters: [Parameters.accept],
  serializer: serializer
};